import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import IClient from "~/Interfaces/IClient";

@Module({ stateFactory: true, namespaced: true, name: 'TeamMembers'})
export default class TeamMembers extends VuexModule {
  members: IClient[] = []

  @Mutation
  setTeamMembers(members: IClient[])
  {
    this.members = members;
  }

  get getTeamMembers(): IClient[]
  {
    return this.members
  }
}
